const Barba = require('barba.js')
const $ = require('jquery')

const hiddenElements = [
	'.main#section0',
	'.nav',
	'.section#section1',
	'.section#section2',
	'.section#drinks',
	'.section#contact',
]

Barba.BaseView.extend({
	namespace: 'home',
	onEnter: function() {

		$("#drinkslist .drink").each(function (index) {
			let $title = $(this).children('.title')
			let $details = $(this).children('.drinkdetails')
			$title.click(function () {
				$details.slideToggle('fast')
			});
		});

		/* Age Gate: */
		let over18 = localStorage.getItem('over18')

		function showHide(elements, state) {
			$.each(elements, function (index, element) {
				if (state == "show") {
					$(element).removeClass('hidden')
					$('body').removeClass('no-scroll')
					$('#agegate').hide()
				} else {
					$(element).addClass('hidden')
					$('body').addClass('no-scroll')
					$('#agegate').show()
				}
			})
		}

		if (over18 !== null) {
			showHide(hiddenElements, "show")
		} else {
			showHide(hiddenElements, "hide")
		}

		$('#ageConfirm').click(function(){
			localStorage.setItem('over18', true);
			showHide(hiddenElements, "show")
		})

	},
	onLeave: function() {
		//
	}
}).init()



// WEBPACK FOOTER //
// source/js/barba/view.home.js